import api from "./api";

// Capa de servicios API del dominio "campañas de grupo" (group-campaigns) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

// --- CRUD ---
export const listGroupCampaigns = () => api.get("/group-campaigns");
export const getGroupCampaign = (campaignId) =>
  api.get(`/group-campaigns/${campaignId}`);
export const getGroupCampaignShipping = (campaignId, params) =>
  api.get(`/group-campaigns/${campaignId}/shipping`, { params });
export const createGroupCampaign = (payload) =>
  api.post("/group-campaigns", payload);
export const updateGroupCampaign = (campaignId, payload) =>
  api.put(`/group-campaigns/${campaignId}`, payload);
export const deleteGroupCampaign = (campaignId) =>
  api.delete(`/group-campaigns/${campaignId}`);

// --- Media ---
export const uploadGroupCampaignMedia = (campaignId, formData) =>
  api.post(`/group-campaigns/${campaignId}/media-upload`, formData);

// --- Control de ejecución ---
export const cancelGroupCampaign = (campaignId) =>
  api.post(`/group-campaigns/${campaignId}/cancel`);
export const stopGroupCampaign = (campaignId) =>
  api.post(`/group-campaigns/${campaignId}/stop`);
export const restartGroupCampaign = (campaignId) =>
  api.post(`/group-campaigns/${campaignId}/restart`);
